export const BLACKLIST_REQUEST = 'BLACKLIST_REQUEST';
export const BLACKLIST_SUCCESS = 'BLACKLIST_SUCCESS';
export const BLACKLIST_FAILED = 'BLACKLIST_FAILED';

export const REMOVE_FROM_BLACKLIST_REQUEST = 'REMOVE_FROM_BLACKLIST_REQUEST';
export const REMOVE_FROM_BLACKLIST_ERROR = 'REMOVE_FROM_BLACKLIST_ERROR';
export const REMOVE_FROM_BLACKLIST_SUCCESS = 'REMOVE_FROM_BLACKLIST_SUCCESS';
